/**
 * Use this file to define "block styles" and other JS for use in the block editor BACKEND.
 *
 * You'll need to acually edit inc/enqueue.php to get the compiled version of this file loaded.
 *
 * See https://www.billerickson.net/block-styles-in-gutenberg/ for documentation.
 */



wp.domReady( () => {
	// Register list styles
	wp.blocks.registerBlockStyle( 'core/list', [
		{
			name: 'default',
			label: 'Default',
			isDefault: true
		},
		{
			name: 'plain',
			label: 'Plain'
		},
		{
			name: 'tight',
			label: 'Tight'
		},
	]);
	// Register button styles
	wp.blocks.registerBlockStyle( 'core/button', [
		{
			name: 'primary',
			label: 'Primary',
			isDefault: true
		},
		{
			name: 'arrow-button',
			label: 'Arrow Button'
		},
		{
			name: 'arrow-button-light',
			label: 'Arrow Button Light'
		},
		{
			name: 'arrow-large',
			label: 'Arrow Large'
		}
	] );
	// Register cover styles
	wp.blocks.registerBlockStyle( 'core/cover', [
		{
			name: 'fade-up',
			label: 'Fade Up'
		},
	] );
	wp.blocks.registerBlockStyle( 'core/cover', [
		{
			name: 'hover-effect',
			label: 'Hover Effect'
		},
	] );
	// Register group styles
	wp.blocks.registerBlockStyle( 'core/group', [
		{
			name: 'lined-header',
			label: 'Lined Header'
		},
	] );
	// Register column styles
	wp.blocks.registerBlockStyle( 'core/columns', [
		{
			name: 'two-column-breakdown',
			label: '2 Column Breakdown'
		},
		{
			name: 'menu-column-breakdown',
			label: 'Menu Column Breakdown'
		},
		{
			name: 'mobile-column-swap',
			label: 'Mobile Column Swap'
		},
	] );
	wp.blocks.registerBlockStyle( 'core/column', [
		{
			name: 'right-divider',
			label: 'Right Divider'
		},
	] );

	// Register image styles
	wp.blocks.registerBlockStyle( 'core/image', [
		{
			name: 'hover-effect',
			label: 'Hover Effect'
		},
	] );

	// Register paragraph styles
	wp.blocks.registerBlockStyle( 'core/paragraph', [
		{
			name: 'subtitle',
			label: 'Subtitle'
		},
	] );
	wp.blocks.registerBlockStyle( 'core/paragraph', [
		{
			name: 'indented',
			label: 'Indented'
		},
	] );
	wp.blocks.registerBlockStyle( 'core/paragraph', [
		{
			name: 'arrow-link',
			label: 'Arrow Link'
		},
	] );
	
	// Unregister default button styles
	wp.blocks.unregisterBlockStyle( 'core/button', 'fill' );
	wp.blocks.unregisterBlockStyle( 'core/button', 'outline' );
} );
